import { Controller } from "stimulus"

// Connects to data-controller="rba-status-polling"
// Compatible with Stimulus 1.x
export default class extends Controller {
  static targets = ["spinner", "message"]

  connect() {
    // Read data attributes manually for Stimulus 1.x compatibility
    this.statusUrl = this.data.get("statusUrl") || "/ridp/rba/status"
    this.pollInterval = parseInt(this.data.get("pollInterval") || "2000")
    this.maxAttempts = parseInt(this.data.get("maxAttempts") || "50")

    this.attemptCount = 0
    this.pollingTimer = null

    this.responseHandlers = {
      'CONTINUE': '/ridp/rba/continue',
      'INVESTIGAT': '/ridp/rba/need_more_info',
      'STOP': '/ridp/rba/exception',
      'NODECISION': '/ridp/rba/no_decision',
      'ERROR': '/ridp/rba/error',
      'HE20040': '/ridp/rba/manual_upload'
    }

    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.pollForResponse()
    this.pollingTimer = setInterval(() => {
      this.pollForResponse()
    }, this.pollInterval)
  }

  stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
      this.pollingTimer = null
    }
  }

  async pollForResponse() {
    this.attemptCount++

    if (this.attemptCount > this.maxAttempts) {
      this.stopPolling()
      this.redirectToManualUploadWithInternalError()
      return
    }

    try {
      const response = await fetch(this.statusUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      })

      if (!response.ok) {
        console.error('HTTP error!')

        if (response.status === 404) {
          this.stopPolling()
          this.redirectToManualUploadWithInternalError()
          return
        }

        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      if (this.hasMessageTarget && data.message) {
        this.messageTarget.textContent = data.message
      }

      if (data.status && data.status !== 'PENDING') {
        this.stopPolling()
        this.handleResponse(data)
      }
    } catch (error) {
      console.error("RBA polling error occurred")

      if (this.attemptCount >= this.maxAttempts) {
        this.stopPolling()
        this.redirectToManualUploadWithInternalError()
      }
    }
  }

  handleResponse(data) {
    const responseCode = data.status

    if (!responseCode) {
      this.redirectToManualUploadWithInternalError()
      return
    }

    const redirectPath = this.responseHandlers[responseCode]

    if (redirectPath) {
      window.location.href = redirectPath
    } else {
      this.redirectToManualUploadWithInternalError()
    }
  }

  redirectToManualUploadWithInternalError() {
    window.location.href = '/ridp/rba/manual_upload?internal_error=true'
  }
}